import { shapes, metal } from './../resources/translations';

export default class Translater {
  static translate(key) {
    const searchableKey = key.toLowerCase();
    if (shapes[searchableKey]) {
      return shapes[searchableKey];
    }
    if (metal[searchableKey]) {
      return metal[searchableKey];
    }
    return key;
  }
}
